import { render, staticRenderFns } from "./AptitudeOccupationalFactors.vue?vue&type=template&id=6c22a602&scoped=true"
import script from "./AptitudeOccupationalFactors.vue?vue&type=script&lang=js"
export * from "./AptitudeOccupationalFactors.vue?vue&type=script&lang=js"
import style0 from "./AptitudeOccupationalFactors.vue?vue&type=style&index=0&id=6c22a602&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c22a602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c22a602')) {
      api.createRecord('6c22a602', component.options)
    } else {
      api.reload('6c22a602', component.options)
    }
    module.hot.accept("./AptitudeOccupationalFactors.vue?vue&type=template&id=6c22a602&scoped=true", function () {
      api.rerender('6c22a602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/seven/components/AptitudeOccupationalFactors.vue"
export default component.exports